import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const CustomPagination = ({
    count,
    page,
    rowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    rowsPerPageOptions,
}) => {
    const totalPages = Math.ceil(count / rowsPerPage);
    const start = count === 0 ? 0 : page * rowsPerPage + 1;
    const end = Math.min((page + 1) * rowsPerPage, count);

    const handleRowsPerPageChange = (e) => {
        onRowsPerPageChange(e);
    };
    const handlePrev = (e) => {
        if (page > 0) onPageChange(e, page - 1);
    };

    const handleNext = (e) => {
        if (page < totalPages - 1) onPageChange(e, page + 1);
    };
    return (
        <Row className="align-items-center justify-content-between mt-3">
            <Col xs="auto">
                <div className="d-flex align-items-center gap-2 flex-nowrap">
                    <span className="text-nowrap">Rows per page:</span>
                    <div className="d-flex w-auto">
                        <Form.Select
                            size="sm"
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="w-auto"
                        >
                            {rowsPerPageOptions.map((option) => (
                                <option key={option} value={option}>
                                    {option}
                                </option>
                            ))}
                        </Form.Select>
                    </div>
                </div>
            </Col>
            <Col xs="auto" className="d-flex align-items-center gap-2">

                <span
                    onClick={handlePrev}
                    className={`pagination-icon ${page === 0 ? 'disabled-icon' : ''}`}
                >
                    <FontAwesomeIcon
                        icon={faChevronLeft}
                        className={`pagination-fa-icon ${page === 0 ? 'icon-disabled' : ''}`}
                    />
                </span>

                <span className="text-muted small">
                    {`${start} - ${end} of ${count}`}
                </span>

                <span
                    onClick={handleNext}
                    className={`pagination-icon ${page >= totalPages - 1 ? 'disabled-icon' : ''}`}
                >
                    <FontAwesomeIcon
                        icon={faChevronRight}
                        className={`pagination-fa-icon ${page >= totalPages - 1 ? 'icon-disabled' : ''}`}
                    />
                </span>
            </Col>
        </Row>
    );
};

export default CustomPagination;
